export default "__VITE_ASSET__9deacb35__"